import { Save } from '@mui/icons-material'
import { Alert, Button, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useAuth, useInputText } from '../../../hooks'
import { removeEmptyFields } from '../../../resources'
import services from '../../../services'

export default function Form() {
  const { user } = useAuth()

  const initialValues = {
    name: user?.name ?? '',
    surname: user?.surname ?? '',
    oldPassword: '',
    newPassword: '',
  }

  const input = useInputText(initialValues)

  const [loading, setLoading] = useState<boolean>(false)
  const [done, setDone] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (error) {
      setDone(false)
    }
    if (done) setTimeout(() => setDone(false), 8000)
  }, [done, error])

  const handleSubmit = async (event: React.FormEvent) => {
    try {
      event?.preventDefault()
      if (error) setError(null)
      setLoading(true)

      const { name, surname, oldPassword, newPassword } = input
      if (oldPassword || newPassword)
        if (oldPassword.toLowerCase() === newPassword.toLowerCase())
          throw new Error(
            'A nova palavra-passe não pode ser igual à antiga palavra-passe',
          )

      const nonEmptyValues = removeEmptyFields({
        name,
        surname,
        oldPassword,
        newPassword,
      })
      await services.user.update({ ...nonEmptyValues, id: user?.id })
      input.newPassword = ''
      input.oldPassword = ''
      setDone(true)
    } catch (error) {
      setError((error as Error).message)
    } finally {
      setDone(false)
      setLoading(false)
    }
  }
  useEffect(() => {
    if (user?.name) {
      input.updateInitial('name', user?.name)
    }
    if (user?.surname) {
      input.updateInitial('surname', user?.surname)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  return (
    <form onSubmit={handleSubmit} className="grid gap-4">
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : done ? (
        <Alert severity="success">Dados atualizados</Alert>
      ) : (
        loading && (
          <Alert severity="warning">A processar a sua informação</Alert>
        )
      )}

      <div>
        <h2 className="font-semibold">A sua informação</h2>
        <p className="text-xs text-disabled">
          Para guardar a informação, tem de introduzir a sua palavra-passe
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <TextField
          disabled={loading}
          autoComplete="off"
          autoFocus
          label="Nome"
          name="name"
          value={input.name}
          onChange={input.onChange}
        />

        <TextField
          disabled={loading}
          autoComplete="off"
          label="Apelido"
          name="surname"
          value={input.surname}
          onChange={input.onChange}
        />

        <TextField
          disabled={loading}
          autoComplete="off"
          required={input.newPassword.length > 0}
          type="password"
          label="Palavra-passe antiga"
          name="oldPassword"
          value={input.oldPassword}
          onChange={input.onChange}
          onBlur={input.onBlur}
          helperText={input.newPassword.length > 0 && input.errors.oldPassword}
          error={!!(input.newPassword.length > 0 && input.errors.oldPassword)}
        />

        <TextField
          disabled={loading}
          autoComplete="off"
          required={input.oldPassword.length > 0}
          type="password"
          label="Nova palavra-passe"
          name="newPassword"
          value={input.newPassword}
          onChange={input.onChange}
          onBlur={input.onBlur}
          helperText={input.oldPassword.length > 0 && input.errors.newPassword}
          error={!!(input.oldPassword.length > 0 && input.errors.newPassword)}
        />
        <div className="flex flex-col justify-start items-start">
          <div className="w-max max-w-full">
            <Button type="submit" disabled={loading}>
              <Save />
              <span className="font-[inherit] text-[inherit] font-semibold capitalize">
                Atualizar
              </span>
            </Button>
          </div>
        </div>
      </div>
    </form>
  )
}
